'use client';

import { pictureAndContentSection } from '@stereoagency/sanity-schema';
import { PictureAndContentSection as UIPictureAndContentSection } from '@stereoagency/ui';
import { SimpleBlockContent } from '../sanity/client';
import { actionAsProps, sanityImageAsProps } from '@/utils';

type Props = typeof pictureAndContentSection.schema.pictureAndContentSection;

export default function PictureAndContentSection({
  variant,
  imageType,
  imageGraphic,
  background,
  image,
  secondaryImage,
  label,
  title,
  description,
  callToActions
}: Props) {
  if (!title || !image?.asset._ref) {
    return null;
  }

  return (
    <UIPictureAndContentSection
      variant={variant}
      imageType={imageType === 'graphic' ? 'pattern' : imageType}
      patternVariant={imageGraphic}
      background={background}
      label={label}
      title={title}
      description={
        description ? <SimpleBlockContent value={description} /> : null
      }
      image={sanityImageAsProps(image)}
      secondaryImage={
        secondaryImage?.asset._ref
          ? sanityImageAsProps(secondaryImage)
          : undefined
      }
      callToActions={callToActions?.map((action) => actionAsProps(action))}
    />
  );
}
